import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardReportModel } from 'src/app/models/dashboard/dashboard-report';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
    selector: 'app-reporting-widget-demo',
    templateUrl: './reporting-widget-demo.component.html',
    styleUrl: './reporting-widget-demo.component.scss',
    standalone: false
})
export class ReportingWidgetDemoComponent {
  reportsListData: DashboardReportModel[] = [
   {
      id: 0,
      name: 'Report',
      description: 'Current status report',
      link: '/reporting-idd',
    }
  ];

  reportsListDataColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.REPORT-NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
      cellTemplate: 'link',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.DESCRIPTION'),
      dataField: 'description',
      dataType: 'string',
      disableFiltering: true,
    },
  ];


  constructor(
    private translateService: TranslateService
  ) {
    
  }
}
